import React from 'react'
import {
  Box,
  Typography,
  Button,
  Stack,
} from '@mui/material'
import SearchOffIcon from '@mui/icons-material/SearchOff'
import InboxIcon from '@mui/icons-material/Inbox'
import FilterListOffIcon from '@mui/icons-material/FilterListOff'

interface EmptyStateProps {
  type?: 'no-data' | 'no-results' | 'no-filters'
  title?: string
  message?: string
  icon?: React.ReactNode
  action?: {
    label: string
    onClick: () => void
    variant?: 'contained' | 'outlined' | 'text'
  }
  height?: number | string
}

const defaultConfig = {
  'no-data': {
    icon: <InboxIcon sx={{ fontSize: 64, color: 'text.disabled' }} />,
    title: 'No hay datos disponibles',
    message: 'No se encontraron registros para mostrar.',
  },
  'no-results': {
    icon: <SearchOffIcon sx={{ fontSize: 64, color: 'text.disabled' }} />,
    title: 'No se encontraron resultados',
    message: 'Intenta ajustar los filtros o criterios de búsqueda.',
  },
  'no-filters': {
    icon: <FilterListOffIcon sx={{ fontSize: 64, color: 'text.disabled' }} />,
    title: 'Configura los filtros',
    message: 'Selecciona los filtros para ver los datos.',
  },
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  type = 'no-data',
  title,
  message,
  icon,
  action,
  height = 400,
}) => {
  const config = defaultConfig[type]

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: typeof height === 'number' ? `${height}px` : height,
        textAlign: 'center',
        px: 3,
      }}
    >
      <Stack spacing={3} alignItems="center" maxWidth={400}>
        {icon || config.icon}
        
        <Stack spacing={1} alignItems="center">
          <Typography
            variant="h6"
            component="h3"
            color="text.primary"
            fontWeight={600}
          >
            {title || config.title}
          </Typography>
          
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ maxWidth: 300 }}
          >
            {message || config.message}
          </Typography>
        </Stack>

        {action && (
          <Button
            variant={action.variant || 'outlined'}
            onClick={action.onClick}
            size="medium"
          >
            {action.label}
          </Button>
        )}
      </Stack>
    </Box>
  )
}

export default EmptyState